import { render, staticRenderFns } from "./TicketGrido.vue?vue&type=template&id=2e36ba32"
import script from "./TicketGrido.vue?vue&type=script&lang=js"
export * from "./TicketGrido.vue?vue&type=script&lang=js"
import style0 from "./TicketGrido.vue?vue&type=style&index=0&id=2e36ba32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports